export const FILING_JOB_STATUS = {
  PROCESSING: 'processing',
  CANCELLED: 'cancelled',
  REVIEW: 'review',
  PREPARING: 'preparing',
  IN_PROGRESS: 'in_progress',
  INITIALIZING: 'initializing',
  INTRASTAT: 'intrastat',
  COMPLETE: 'complete',
  UPLOAD: 'upload',
  SPREADSHEET: 'spreadsheet',
  MAPPING: 'mapping',
} as const;

export const JOB_STATE = {
  GET_STARTED: 'get_started',
  PROCESSING: 'processing',
} as const;

export const FILING_TYPES = {
  AR: 'AR',
  ECSL: 'ECSL',
  INT: 'INT',
  VAT: 'VAT',
  VPMT: 'VPMT',
  IOSS: 'IOSS',
  OSS: 'OSS',
} as const;

export const LIST_FILINGS = {
  MY_FILINGS: 'MY_FILINGS',
  ALL_FILINGS: 'ALL_FILINGS',
} as const;

export const DOWNLOAD_VAT_FILES = {
  DRAFT_RETURN: 'DRAFT_RETURN',
  FILED_RETURN: 'FILED_RETURN',
  SAFT: 'SAFT',
  XML: 'XML',
} as const;

export const FILING_TABS = {
  PREPARE: 'prepare',
  RETURN: 'return',
  PAYMENT: 'payment',
  ECSL: 'ecsl',
  ECPL: 'ecpl',
} as const;

export const CONVERSION_TOOL_STEPS = {
  selectFields: 'selectFields',
  selectRowPosition: 'selectRowPosition',
  selectHeaderPosition: 'selectHeaderPosition',
  saving: 'saving',
  error: 'error',
} as const;

export const CONVERSION_TOOL = {
  MAX_TABLE_COLUMNS_COUNT: 50,
  MAX_TABLE_ROWS_COUNT: 15,
  MIN_ROW_AND_HEADER: 1,
  MAX_ROW_AND_HEADER: 50,
} as const;
